import { NavLink, Outlet } from 'react-router-dom';
import BrandLogo from '@/components/BrandLogo';
import { cn } from '@/lib/cn';

const navLinks = [
  { to: '/', label: 'Home', end: true },
  { to: '/about', label: 'About' },
  { to: '/products', label: 'Products' },
  { to: '/services', label: 'Services' },
  { to: '/contact', label: 'Contact Us' },
];

export default function SiteLayout() {
  return (
    <div className="flex min-h-screen flex-col overflow-x-hidden bg-white">
      <header className="sticky top-0 z-50 border-b border-slate-200 bg-white/95 backdrop-blur">
        <div className="mx-auto flex max-w-6xl items-center justify-between gap-3 px-4 py-3 sm:gap-4 sm:px-6 lg:px-8">
          <NavLink to="/" className="min-w-0 shrink transition opacity-95 hover:opacity-100">
            <BrandLogo
              variant="horizontal"
              className="h-8 max-w-[11rem] sm:h-9 sm:max-w-none md:h-10"
            />
          </NavLink>

          <nav className="hidden items-center gap-1 md:flex">
            {navLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.end}
                className={({ isActive }) =>
                  cn(
                    'rounded-lg px-3 py-2.5 text-base font-bold transition',
                    isActive
                      ? 'bg-brand-50 text-brand-700'
                      : 'text-slate-600 hover:bg-slate-50 hover:text-brand-700'
                  )
                }
              >
                {link.label}
              </NavLink>
            ))}
          </nav>

          <NavLink to="/contact" className="btn-primary hidden shrink-0 sm:inline-flex sm:w-auto">
            Get in touch
          </NavLink>

          <NavLink
            to="/contact"
            className="btn-primary !w-auto inline-flex shrink-0 px-4 py-2.5 text-sm sm:hidden"
          >
            Contact
          </NavLink>
        </div>

        <nav className="mobile-nav snap-x snap-mandatory">
          {navLinks.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={link.end}
              className={({ isActive }) =>
                cn(
                  'mobile-nav-link',
                  isActive ? 'bg-brand-50 text-brand-700' : 'text-slate-600'
                )
              }
            >
              {link.label}
            </NavLink>
          ))}
        </nav>
      </header>

      <main className="flex-1">
        <Outlet />
      </main>

      <footer className="border-t border-slate-200 bg-slate-50 text-slate-600">
        <div className="mx-auto max-w-6xl px-4 py-10 sm:px-6 sm:py-12 lg:px-8">
          <div className="grid gap-8 sm:grid-cols-2 md:grid-cols-3">
            <div className="sm:col-span-2 md:col-span-1">
              <BrandLogo variant="horizontal" className="h-6 max-w-[10rem] sm:h-7 sm:max-w-none" />
              <p className="mt-4 text-base font-semibold leading-relaxed">
                A boutique software firm crafting bespoke applications for businesses across
                Malaysia — with personal attention and craftsmanship in every delivery.
              </p>
            </div>
            <div>
              <p className="text-lg font-bold text-brand-900">Quick links</p>
              <ul className="mt-3 space-y-2 text-base font-semibold">
                {navLinks.map((link) => (
                  <li key={link.to}>
                    <NavLink to={link.to} className="inline-block min-h-10 py-1 hover:text-brand-700">
                      {link.label}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="text-lg font-bold text-brand-900">Contact</p>
              <ul className="mt-3 space-y-2 text-base font-semibold">
                <li>
                  <a
                    href="https://www.adsperianx.com.my"
                    className="inline-block min-h-10 break-all py-1 hover:text-brand-700"
                  >
                    www.adsperianx.com.my
                  </a>
                </li>
                <li>
                  <NavLink to="/contact" className="inline-block min-h-10 py-1 hover:text-brand-700">
                    Send us a message
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>
          <p className="mt-8 border-t border-slate-200 pt-6 text-center text-sm font-semibold text-slate-500 sm:mt-10">
            &copy; {new Date().getFullYear()} ADSPERIANX SOLUTIONS. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}
